<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white">
      <h4 class="mb-0">IT Account Creation</h4>
      <h6 class="mb-0">IT Department</h6>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <!-- Employee Code -->
        <!-- <div class="col-md-5">
          <label for="employeeId" class="form-label">Employee Code</label>
          <select id="employeeId" class="form-select form-select-sm" #Reporterid [(ngModel)]="add.OD_EmployeeID" (keydown.enter)="ADusername.focus()" (change)="getemployeedetails(add.OD_EmployeeID)" name="Reporterid" >
            <option value="">-- Select --</option>
            <option *ngFor="let emp of appservice.Itcreationemployeeid" [value]="emp.OD_EmployeeID">{{ emp.OD_EmployeeID }}</option>
          </select>
        </div> -->
          <div class="col-md-5">
          <label for="OD_EmployeeID" class="form-label">Employee Code</label>
          <input type="text" id="OD_EmployeeID" class="form-control form-control-sm" (keyup)="getemployeedetails(add.OD_EmployeeID)" [(ngModel)]="add.OD_EmployeeID" />
        </div>
        <!-- Name -->
        <div class="col-md-5">
          <label for="name" class="form-label">Name</label>
          <input type="text" id="name" class="form-control form-control-sm" [(ngModel)]="add.name" />
        </div>
        <!-- Designation -->
        <div class="col-md-5">
          <label for="designation" class="form-label">Designation</label>
          <input type="text" id="designation" class="form-control form-control-sm" [(ngModel)]="add.designation" />
        </div>
        <!-- Grade -->
        <div class="col-md-5">
          <label for="grade" class="form-label">Location</label>
          <input type="text" id="grade" class="form-control form-control-sm" [(ngModel)]="add.grade" />
        </div>
        <!-- Date of Join -->
        <div class="col-md-5">
          <label for="dateofjoin" class="form-label">Date of Joining</label>
          <input type="date" id="dateofjoin" class="form-control form-control-sm" [(ngModel)]="add.dateofjoin" />
        </div>
        <!-- Plant -->
        <div class="col-md-5">
          <label for="plant" class="form-label">Plant</label>
          <input type="text" id="plant" class="form-control form-control-sm" [(ngModel)]="add.plant" />
        </div>
        <!-- Department -->
        <div class="col-md-5">
          <label for="department" class="form-label">Department</label>
          <input type="text" id="department" class="form-control form-control-sm" [(ngModel)]="add.department" />
        </div>
        <!-- Requester Name -->
        <div class="col-md-5">
          <label for="requestername" class="form-label">Requester</label>
          <input type="text" id="requestername" class="form-control form-control-sm" [(ngModel)]="add.requestername" />
        </div>
        <!-- Checker Name -->
        <div class="col-md-5">
          <label for="checkername" class="form-label">Checker</label>
          <input type="text" id="checkername" class="form-control form-control-sm" [(ngModel)]="add.checkername" />
        </div>
        <!-- Final Approver Name -->
        <div class="col-md-5">
          <label for="finalapprovername" class="form-label">Approver</label>
          <input type="text" id="finalapprovername" class="form-control form-control-sm" [(ngModel)]="add.finalapprovername" />
        </div>
        <!-- AD Username -->
        <div class="col-md-5">
          <label for="adUsername" class="form-label">AD User Name</label>
          <input type="text" id="adUsername" #ADusername class="form-control form-control-sm" [(ngModel)]="add.ADusername"  />
        </div>
        <!-- Contact Mail ID -->
        <div class="col-md-5">
          <label for="contactMail" class="form-label">Mail ID</label>
          <input type="email" id="contactMail" #contactMail class="form-control form-control-sm" [(ngModel)]="add.contactMail"  />
        </div>
      </div>
      <div class="col-md-5">
        <button type="submit" class="btn btn-submit" (click)="onSubmit()">Submit</button>
         <button type="submit" class="btn btn-cancel" (click)="appservice.goback()">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Submit Button 
  <button type="submit" class="btn btn-submit" (click)="onSubmit()">Submit</button>-->
  <!--</form>-->
</div>
